import React, { useEffect, useState } from "react";
import axios from "axios";
import BuyerDashboard from "./Buyer/BuyerDashboard.jsx";
import { useNavigate } from "react-router-dom";
import ApproverDashboard from "./Others/ApproverDashboard.jsx";
import ServiceOrderDashboard from "./Buyer/Dashboards/ServiceOrderDashboard.jsx";
import { Button, Box } from "@mui/material";
import VendorBalanceDashboard from "./Buyer/Dashboards/VendorBalanceDashboard.jsx";
import InvoiceApprovalDashboard from "./Buyer/Dashboards/InvoiceApprovalDashboard.jsx";
import CustomerApprovalDashboard from "./Buyer/Dashboards/CustomerApprovalDashboard.jsx";
import TradeMarketingDashboard from "./Buyer/Dashboards/TradeMarketingDashboard.jsx";
import CustomerBalanceDashboard from "./Buyer/Dashboards/CustomerBalanceDashboard.jsx";
import AdvanceGivenDashboard from "./Buyer/Dashboards/AdvanceGivenDashboard.jsx";
import DepositGivenDashboard from "./Buyer/Dashboards/DepositGivenDashboard.jsx";
import OtherDashboard from "./Buyer/Dashboards/OtherDashboard.jsx";
import CustomerDepositDashboard from "./Buyer/Dashboards/CustomerDepositDashboard.jsx";
import TenderDepositDashboard from "./Buyer/Dashboards/TenderDepositDashboard.jsx";
import VendorAdvanceDashboard from "./Buyer/Dashboards/VendorAdvanceDashboard.jsx";
import InventoryDashboard from "./Buyer/Dashboards/InventoryDashboard.jsx";
import VendorApprovalDashboard from "./Buyer/Dashboards/VendorApprovalDashboard.jsx";
import SuperuserDashboard from "./Others/SuperuserDashboard.jsx";
import FinanceProcessorDashboard from "./Others/FinanceProcessorDashboard.jsx";
import AccountPayableDashboard from "./Others/AccountPayableDashboard.jsx";

const Dashboard = () => {
  const [user, setUser] = useState(null);
  const [dashboard, setDashboard] = useState(
    JSON.parse(localStorage.getItem("dashboard"))
  );
  // const [type, setType] = useState(JSON.parse(localStorage.getItem("type")));
  const [dropdown, setDropdown] = useState("");
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();

  useEffect(() => {
    const dash = JSON.parse(localStorage.getItem("dashboard"));
    const type = JSON.parse(localStorage.getItem("type"));

    if (dash && type) {
      setDropdown(`${dash}-${type}`);
    } else {
      setDropdown(dash);
    }
    setDashboard(dash);
  }, []);

  useEffect(() => {
    const updateDropdown = () => {
      const dash = JSON.parse(localStorage.getItem("dashboard"));
      const type = JSON.parse(localStorage.getItem("type"));

      if (
        type &&
        [
          "VENDOR",
          "CUSTOMER_BALANCE",
          "ADVANCE",
          "DEPOSIT",
          "INVENTORY",
          "OTHER",
        ].includes(dash)
      ) {
        setDropdown(`${dash}-${type}`);
      } else {
        setDropdown(dash);
      }
      setDashboard(dash);
    };

    window.addEventListener("storage", updateDropdown);
    return () => window.removeEventListener("storage", updateDropdown);
  }, []);

  useEffect(() => {
    const getOrgUser = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/org-user?username=${storedUser.username}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setUser(res.data);
      } catch (error) {
        alert(error.response?.data?.Exception || "Access denied");
        localStorage.clear();
        navigate("/");
      }
    };
    getOrgUser();
  }, []);

  const handleChange = (e) => {
    let dashboard = e.target.value;
    let type = null;

    if (e.target.value.includes("-")) {
      const [code, tb] = e.target.value.split("-");
      type = tb === "Off" ? "Off" : "Back";
      dashboard = code;
    }
    localStorage.setItem("dashboard", JSON.stringify(dashboard));
    setDashboard(dashboard);
    setDropdown(e.target.value);
    localStorage.setItem("type", JSON.stringify(type));
  };

  if (!user) return null;

  if (user.userRoleName !== "BUYER") {
    if (user.userRoleName === "FINANCE_PROCESSOR") {
      return <FinanceProcessorDashboard />
    }
    if (user.userRoleName === "ACCOUNT_PAYABLE_TEAM") {
      return <AccountPayableDashboard />
    }
    if (user.userRoleName === "SUPERUSER") {
      return <SuperuserDashboard />
    }
    return <ApproverDashboard />;
  }

  const handleBack = () => {
    localStorage.removeItem("dashboard");
    localStorage.removeItem("type");
    setDashboard(null);
  };

  return (
    <Box sx={{ p: 2 }}>
      {dashboard && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Button className="btn-outlined" onClick={handleBack}>
            Back
          </Button>
          <select
            name=""
            id=""
            onChange={handleChange}
            value={dropdown}
            style={{ width: "30%", background: "transparent" }}
          >
            <option value="SERVICE">Service Order Approval</option>
            <option value="INVOICE">Invoice Approval</option>
            <option value="CUSTOMER">New Customer Approval</option>
            <option value="VENDOR_APPROVAL">New Vendor Approval</option>
            <option value="TRADE">Trade Marketing Scheme</option>
            <option value="VENDOR_ADVANCE">Vendor Advance</option>
            <option value="CUSTOMER_DEPOSIT">Customer Deposit</option>
            <option value="TENDER_DEPOSIT">Tender Deposit</option>
            <option value="VENDOR-Off">Write Off - Vendor Balances</option>
            <option value="CUSTOMER_BALANCE-Off">
              Write Off - Customer Balances
            </option>
            <option value="ADVANCE-Off">Write Off - Advances Given</option>
            <option value="DEPOSIT-Off">Write Off - Deposit Given</option>
            <option value="INVENTORY-Off">Write Off - Inventory</option>
            <option value="OTHER-Off">Write Off - Others</option>

            <option value="VENDOR-Back">Write Back - Vendor Balances</option>
            <option value="CUSTOMER_BALANCE-Back">
              Write Back - Customer Balances
            </option>
            <option value="ADVANCE-Back">Write Back - Advances Given</option>
            <option value="DEPOSIT-Back">Write Back - Deposit Given</option>
            <option value="INVENTORY-Back">Write Back - Inventory</option>
            <option value="OTHER-Back">Write Back - Others</option>
          </select>
        </Box>
      )}
      {dashboard === "SERVICE" && <ServiceOrderDashboard />}
      {dashboard === "VENDOR" && <VendorBalanceDashboard dropdown={dropdown} />}
      {dashboard === "INVOICE" && <InvoiceApprovalDashboard />}
      {dashboard === "CUSTOMER" && <CustomerApprovalDashboard />}
      {dashboard === "VENDOR_APPROVAL" && <VendorApprovalDashboard />}
      {dashboard === "TRADE" && <TradeMarketingDashboard />}
      {dashboard === "CUSTOMER_BALANCE" && (
        <CustomerBalanceDashboard dropdown={dropdown} />
      )}
      {dashboard === "ADVANCE" && <AdvanceGivenDashboard dropdown={dropdown} />}
      {dashboard === "DEPOSIT" && <DepositGivenDashboard dropdown={dropdown} />}
      {dashboard === "INVENTORY" && <InventoryDashboard dropdown={dropdown} />}
      {dashboard === "OTHER" && <OtherDashboard dropdown={dropdown} />}
      {dashboard === "CUSTOMER_DEPOSIT" && <CustomerDepositDashboard />}
      {dashboard === "TENDER_DEPOSIT" && <TenderDepositDashboard />}
      {dashboard === "VENDOR_ADVANCE" && <VendorAdvanceDashboard />}

      {!dashboard && <BuyerDashboard setDashboard={setDashboard} />}
    </Box>
  );
};

export default Dashboard;
